module.exports = __webpack_public_path__ + "static/media/08EchoMountainmuralinstallatiobeginning.a73aae91.webp";